import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { sortingTypes } from './constants'

const SortingSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value}
        label={t('Ordenación métodos de envío')}
        fullWidth
        handleChange={handleChange}
        menuItems={sortingTypes.map(type => ({ label: t(type.label), value: type.value }))}
      />
    </div>
  )
}

export default SortingSelector
